import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';
import { Entity } from '../select-list/select-list.component';
import { MyUtility } from '../../comparison';

@Component({
  selector: 'app-custom',
  templateUrl: './custom.component.html',
  styleUrls: ['./custom.component.css']
})
export class CustomComponent implements OnInit {
  customName : string = "Custom1";//TODO: This needs to be passed in, not hardcoded
  preCtor = true;
  public title : string;

  constructor(private api : ApiService) 
  {
    console.log("ctor");
    this.preCtor = false;
  }

  ngOnInit() {
  }

  get items(){
    return this.api.session.customValues[this.customName];
  }

  ensureCriteriaExists(){
    if(!this.api.session.currentCriteria.customCriteria[this.customName]){
      this.api.session.currentCriteria.customCriteria[this.customName] = {selectedItems:[]};
      console.log("setting custom criteria");
    }
  }

  get selectedItems() : Entity[]{
      console.log("selectedItems get");
      this.ensureCriteriaExists();
      return this.api.session.currentCriteria.customCriteria[this.customName].selectedItems;
  }
  set selectedItems(value){
    if(this.preCtor)
      return;

    console.log("selectedItems set: " + JSON.stringify(value));

    MyUtility.scrubChildren(value);
    
    this.ensureCriteriaExists();
    this.api.session.currentCriteria.customCriteria[this.customName].selectedItems = value;
  }

  get groupName(){
    return this.api.session.currentCriteria.customCriteria[this.customName].groupName;
  }
  set groupName(value){
    this.api.session.currentCriteria.customCriteria[this.customName].groupName = value;
  }

  clearCurrent(){
    this.api.session.currentCriteria.customCriteria[this.customName] = {selectedItems:[]};
  }
}
